export default "__VITE_ASSET__CgvyfuWn__"